/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : mfa.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import actionType from "../actionTypes";

const mfaActions = {
  getSwagger: {
    api_name: "/IAM/v1/mfa/swagger",
    https_method: "POST",
    action_type: actionType.MFA_ACTIONS,
    description: "",
  },
  deleteModule: {
    api_name: "/IAM/v1/mfa/module/delete",
    https_method: "PUT",
    action_type: actionType.DELETE_MODULE,
    description: "",
  },
  deleteFeature: {
    api_name: "/IAM/v1/mfa/feature/delete",
    https_method: "PUT",
    action_type: actionType.DELETE_FEATURE,
    description: "",
  },
  deleteAction: {
    api_name: "/IAM/v1/mfa/action/delete",
    https_method: "PUT",
    action_type: actionType.DELETE_ACTION,
    description: "",
  },
  createModule: {
    api_name: "/IAM/v1/mfa/module/create",
    https_method: "POST",
    action_type: actionType.CREATE_MODULE,
    description: "",
  },
  createFeature: {
    api_name: "/IAM/v1/mfa/feature/create",
    https_method: "POST",
    action_type: actionType.CREATE_FEATURE,
    description: "",
  },
  createAction: {
    api_name: "/IAM/v1/mfa/action/create",
    https_method: "POST",
    action_type: actionType.CREATE_ACTION,
    description: "",
  },
  getModuleMapping: {
    api_name: "/IAM/v1/mfa/module_mappings/get",
    https_method: "POST",
    action_type: actionType.GET_MODULE_MAPPING,
    description: "",
  },
};

export default mfaActions;
